import React, { useState, useEffect, Suspense } from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { ImportMDStyle } from './ImportMD.css';


const MarkdownLoadable = React.lazy(() => import('./ImportedMD'))

export default ({ url, removeTitle = false }) => {
  const [content, setContent] = useState(null)
  const [failedToLoad, setFailedToLoad] = useState(false)
  const [blinkPrevented, setBlinkPrevented] = useState(false)

  // useEffect to get access to fetch
  useEffect(() => {

    setTimeout(() => {
      setBlinkPrevented(true)
    }, 500);

    fetch(url)
      .then(r => (r.ok ? r.text() : Promise.reject()))
      .then(setContent)
      .catch(() => setFailedToLoad(true))
  }, [])

  if(failedToLoad){
    console.error(`Failed to load content from ${url}`)
    return <div css={ImportMDStyle}>
        <SkeletonTheme color="#ffebee" highlightColor="#FAF9F6">
          Ojdå, vi misslyckades att ladda detta innehåll 😢
          <Skeleton count={5} />
        </SkeletonTheme>
      </div>
  }

  if(content == null || !blinkPrevented){
    return <div css={ImportMDStyle}>
      <Skeleton count={5} />
    </div>
  } 

  return <div css={ImportMDStyle}>
          <Suspense fallback={<Skeleton count={5} />}>
            <MarkdownLoadable removeTitle={removeTitle} url={url}>{content}</MarkdownLoadable>
          </Suspense>
        </div>
}
